import React from "react"
import Pagination from "react-bootstrap/Pagination"
import { IParams } from "./types";
import { updateQueryParam, useParamsContext } from "./contexts/ParamsProvider";
import * as s from "./ProductSearch.module.scss"

export const ProductSearchPagination = ({ onChange, config }: {
  onChange: (params: IParams) => void | Promise<void>;
  config: undefined | {
    total_page: number,
    next_page: number | null,
    prev_page: number | null,
    current_page: number
  }
}) => {

  const { params } = useParamsContext();
  const setPage = (page: number): React.MouseEventHandler => {
    return () => {
      const p = {...params, page}
      updateQueryParam(p)
      onChange(p)

      window.scrollTo({top: 0, behavior: "smooth"})
    }
  }
  const current_page = config?.current_page || Number(params.page) || 1

  return <Pagination className={`justify-content-center ${s.pagination}`}>
    <Pagination.First className={s.paginationButton} disabled={current_page == 1} onClick={setPage(1)} />
    {config?.prev_page &&  <Pagination.Prev className={s.paginationButton} onClick={setPage(config.prev_page)} />}
    {current_page - 3 >= 1 && <Pagination.Item className={s.paginationButton} disabled={current_page == 1}>{1}</Pagination.Item>}
    {current_page - 3 >= 1 && <Pagination.Ellipsis className={s.paginationButton} />}

    {current_page - 2 >= 1 && <Pagination.Item className={s.paginationButton} onClick={setPage(current_page - 2)}>{current_page - 2}</Pagination.Item>}
    {current_page - 1 >= 1 && <Pagination.Item className={s.paginationButton} onClick={setPage(current_page - 1)}>{current_page - 1}</Pagination.Item>}
    <Pagination.Item className={`${s.paginationButton} ${s.active}`} active>{current_page}</Pagination.Item>
    {current_page + 1 <= config?.total_page && <Pagination.Item className={s.paginationButton} onClick={setPage(current_page + 1)}>{current_page + 1}</Pagination.Item>}
    {current_page + 2 <= config?.total_page && <Pagination.Item className={s.paginationButton} onClick={setPage(current_page + 2)}>{current_page + 2}</Pagination.Item>}

    {current_page + 3 <= config?.total_page && <Pagination.Ellipsis className={s.paginationButton} />}
    {current_page + 3 <= config?.total_page && config?.total_page && <Pagination.Item className={s.paginationButton} onClick={setPage(config.total_page)}>{config.total_page}</Pagination.Item>}
    {config?.next_page && <Pagination.Next className={s.paginationButton} onClick={setPage(config.next_page)} />}
    {config?.total_page != undefined && <Pagination.Last className={s.paginationButton} disabled={current_page == config.total_page || config.total_page == 0} onClick={setPage(config.total_page)} />}
  </Pagination>
}
